// import React from 'react';
// import icon1 from '../../icons/icon_dollar_2.svg';
// import icon2 from '../../icons/icon_bank_building.svg';
// import icon3 from '../../icons/icon_scan.svg';
// import icon4 from '../../images/services/icon_pinpoint.png';
// import shape1 from '../../images/shapes/shape_section_divider_1.svg';
// import sImg from '../../images/services/ico_service_image.webp';
// import shape2 from '../../images/shapes/shape_poligon.svg';


// const services = [
//   {
//     icon: icon1,
//     title: 'Unified Ecosystem',
//     description: 'All-in-one platform: identity, privacy, smart contracts, and development tools.',
//     delay: 200,
//   },
//   {
//     icon: icon2,
//     title: 'Confidential & Fast',
//     description: 'Advanced cryptography keeps data private—without compromising transaction speed.',
//     delay: 300,
//   },
//   {
//     icon: icon3,
//     title: 'No Extra Hardware',
//     description: 'Secure access anytime, anywhere—no biometric devices or tools needed.',
//     delay: 400,
//   },
//   {
//     icon: icon4,
//     title: 'Built for Builders',
//     description: 'Empowering developers with resources, grants, and community-driven innovation support.',
//     delay: 500,
//   },
// ];

// const ChooseSection = () => {
//   return (
//     <section id="id_ico_service_section" className="ico_service_section section_space pb-0 section_decoration section_shadow_top">
//       <div className="decoration_item shape_divider_1">
//         <img src={shape1} alt="Shape Divider" />
//       </div>

//       <div className="container">
//         <div className="ico_heading_block text-center mt-lg-4" data-aos="fade-up" data-aos-duration="600">
//           <h2 className="heading_text mb-0">Why You Choose Panda Sovereign?</h2>
//         </div>

//         <div className="row m-lg-0 justify-content-center">
//           <div className="col-lg-4 p-lg-0" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
//             <div className="ico_service_image">
//               <img src={sImg} alt="ICO Service Icon" />
//             </div>
//           </div>
//           {services.map((service, index) => (
//             <div key={index} className={`col-lg-4 p-lg-0 ${index === 0 ? 'order-lg-first' : ''}`} data-aos="fade-up" data-aos-duration="600" data-aos-delay={service.delay}>
//               <div className="ico_iconbox_block">
//                 <div className="iconbox_icon">
//                   <img src={service.icon} alt={service.title} />
//                 </div>
//                 <div className="iconbox_info">
//                   <h3 className="iconbox_title">{service.title}</h3>
//                   <p className="iconbox_description mb-0">{service.description}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div className="decoration_item shape_shadow_1">
//         <img src={shape2} alt="Shape Color Shadow" />
//       </div>
//       <div className="decoration_item shape_shadow_2">
//         <img src={shape2} alt="Shape Color Shadow" />
//       </div>
//     </section>
//   );
// };

// export default ChooseSection;

import { useApi } from "../../hooks/useApi"
import icon1 from "../../icons/icon_dollar_2.svg"
import shape1 from "../../images/shapes/shape_section_divider_1.svg"
import sImg from "../../images/services/ico_service_image.webp"
import shape2 from "../../images/shapes/shape_poligon.svg"

const ChooseSection = () => {
  const { data: chooseData, loading, error } = useApi("/choose")

  if (loading) {
    return (
      <section
        id="id_ico_service_section"
        className="ico_service_section section_space pb-0 section_decoration section_shadow_top"
      >
        <div className="container">
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </section>
    )
  }

  if (error || !chooseData) {
    return null
  }

  return (
    <section
      id="id_ico_service_section"
      className="ico_service_section section_space pb-0 section_decoration section_shadow_top"
    >
      <div className="decoration_item shape_divider_1">
        <img src={shape1 || "/placeholder.svg"} alt="Shape Divider" />
      </div>

      <div className="container">
        <div className="ico_heading_block text-center mt-lg-4" data-aos="fade-up" data-aos-duration="600">
          <h2 className="heading_text mb-0">{chooseData.heading}</h2>
        </div>

        <div className="row m-lg-0 justify-content-center">
          <div className="col-lg-4 p-lg-0" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
            <div className="ico_service_image">
              <img src={chooseData.centerImage || sImg} alt="ICO Service Icon" />
            </div>
          </div>
          {chooseData.services?.map((service, index) => (
            <div
              key={index}
              className={`col-lg-4 p-lg-0 ${index === 0 ? "order-lg-first" : ""}`}
              data-aos="fade-up"
              data-aos-duration="600"
              data-aos-delay={service.delay || 200 + index * 100}
            >
              <div className="ico_iconbox_block">
                <div className="iconbox_icon">
                  <img src={service.icon || icon1} alt={service.title} />
                </div>
                <div className="iconbox_info">
                  <h3 className="iconbox_title">{service.title}</h3>
                  <p className="iconbox_description mb-0">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="decoration_item shape_shadow_1">
        <img src={shape2 || "/placeholder.svg"} alt="Shape Color Shadow" />
      </div>
      <div className="decoration_item shape_shadow_2">
        <img src={shape2 || "/placeholder.svg"} alt="Shape Color Shadow" />
      </div>
    </section>
  )
}

export default ChooseSection
